import { merge } from '../../helper';

// ----------------------------------------------------------------------------

function update(element: HTMLTableElement, config: Record<string, any> = {}): void {
    // If table is no table element
    if (!(element instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return;
    }

    // Foreach Rows
    for (const elRow of element.rows) {

        //
        elRow.style.height = '0px';

        //
        if (elRow.style.display === 'none') {
            continue;
        }

        //
        let columnHeight = 0;

        // Foreach Columns
        for (const elColumn of elRow.cells) {

            //
            elColumn.style.width = '0px';

            //
            if (elColumn.style.display === 'none') {
                continue;
            }

            //
            let itemWidth = 0;
            let itemHeight = 0;

            // Foreach Column Children
            for (const elItem of elColumn.children) {

                //
                itemWidth += elItem.clientWidth + 1;
                itemHeight += elItem.clientHeight + 1;
            }

            //
            if (!itemHeight || !itemWidth) {
                elColumn.style.width = '0px';
                continue;
            }

            //
            elColumn.style.width = itemWidth + 'px';

            //
            columnHeight = columnHeight < itemHeight ? itemHeight : columnHeight;
        }

        //
        if (!columnHeight) {
            elRow.style.height = '0px';
            continue;
        }

        //
        elRow.style.height = columnHeight + 'px';
    }
}

function scroll(element: HTMLElement, config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // --------------------------------------------------------------------

    // If there is element table scroll, if not, it is table
    element = element.closest('.table-scroll') ?? element;

    // Get element (table scroll body)
    const elTableScrollBody = element.querySelector<HTMLElement>('.table-scroll-body');
    // If there is no element (table scroll body)
    if (!elTableScrollBody) {
        return;
    }

    // Get element (scroll body > thead)
    const listHeadCell = elTableScrollBody.querySelectorAll<HTMLElement>('thead > tr:first-child > th');

    // Get element (table scroll head)
    const elTableScrollHead = element.querySelector<HTMLElement>('.table-scroll-head');
    // If there is no element (table scroll head)
    if (!elTableScrollHead) {
        return;
    }

    // Get element (scroll head > thead)
    const listBodyCell = elTableScrollHead.querySelectorAll<HTMLElement>('thead > tr:first-child > th');

    // --------------------------------------------------------------------

    // Foreach Cell (Reset)
    for (let i = 0; i < listBodyCell.length; i++) {
        const elHeadCell = listHeadCell[i];
        const elBodyCell = listBodyCell[i];

        // Reset
        elBodyCell.style.width = '0px';
        elHeadCell.style.width = '0px';
    }

    // Foreach Cell
    for (let i = 0; i < listBodyCell.length; i++) {
        const elHeadCell = listHeadCell[i];
        const elBodyCell = listBodyCell[i];

        // Custom
        elBodyCell.style.width = elHeadCell.offsetWidth + 'px';
        elHeadCell.style.width = elHeadCell.offsetWidth + 'px';
    }
}

// ----------------------------------------------------------------------------

export { update, scroll };
